export const API_BASE_URL_DEV = 'https://staging.api.dbutt.ftapp.ng';
export const API_PAGE_LIMIT = 100;
export const API_PAGE_OFFSET = 0;
